import { NgModule } from '@angular/core';
import { TextMaskDirective } from './text-mask.directive';

@NgModule({
    declarations: [TextMaskDirective],
    exports: [TextMaskDirective],
})
export class TextMaskModule {}
